"use strict";

module.exports = class {

    isTimestamp(input) {
        return /^\d+$/.test(input);
    }

    getSourceURL() {
        return (location.href !== 'undefined') ? location.href : '';
    }

    getUserAgent() {
        return (navigator.userAgent !== 'undefined') ? navigator.userAgent : '';
    }

    getDateCreated() {
        return (new Date()).toISOString();
    }

    parseHTML(escapedString='') {
        const dom = new DOMParser().parseFromString(escapedString + '', 'text/html');
        return dom.documentElement.textContent;
    }

    generateQueryString(params) {
        params = (params) ? params : {};
        return Object.keys(params).map((key) => {
            return (typeof params[key] == 'string' || typeof params[key] == 'boolean') ? key + '=' + encodeURIComponent(params[key]) : ((params[key] == null) ? '' : key + '=' + encodeURIComponent(params[key].join(',')));
        }).join('&');
    }

    generateCacheKeyFromOptions(options={}) {
        if (!options || !(options instanceof Object)) {
            return null;
        }

        let defaultOptions = {
            zip_code: '', 
            zc2market: ''
        };

        const mergedOptions = {...defaultOptions, ...options};

        return (mergedOptions.zip_code + mergedOptions.zc2market).replace(' ', '_');
    }

    transformToFormattedDateTimeString(input) {
        const dateOptions = {
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        };

        const inputDate = (this.isTimestamp(input)) ? new Date(Number(input)) : new Date(input);
        const dateParts = new Intl.DateTimeFormat('en-US', dateOptions).formatToParts(inputDate);
        
        const month = dateParts.find(part => part.type === 'month').value ?? null;
        const day = dateParts.find(part => part.type === 'day').value ?? null;
        const hour = dateParts.find(part => part.type === 'hour').value ?? null;
        const minute = dateParts.find(part => part.type === 'minute').value ?? null;
        const period = dateParts.find(part => part.type === 'dayPeriod').value ?? null;
        const timezone = dateParts.find(part => part.type === 'timeZoneName').value ?? null;

        return `<span class="datetime-date"><span class="datetime-date-month">${month}</span>/<span class="datetime-date-day">${day}</span></span>\u00A0<span class="datetime-time"><span class="datetime-time-hour">${hour}</span>:<span class="datetime-time-minute">${minute}${period}</span>\u00A0<span class="datetime-time-timezone d-none d-md-inline">${timezone}</span></span>`;
    }

    normalizeRedirectURL(url) {
        let redirectURL = null;

        if (url.substring(0,7) == 'http://' || url.substring(0,7) == 'https://') {
            redirectURL = new URL(url);
        } else if (url.substr(0,1) == '/') {
            redirectURL = new URL((location.origin + url).split('//' + url).join('/' + url));
        } else {
            let originSlash = (location.origin.substring(location.origin.length - 1, location.origin.length) == '/' || location.pathname.substring(0,1) == '/') ? '' : '/';
            let pathnameSlash = (location.pathname.substring(location.pathname.length - 1, location.pathname.length) == '/' || url.substr(0,1) == '/') ? '' : '/';
            redirectURL = new URL(location.origin + originSlash + location.pathname + pathnameSlash + url);
        }
        
        return (redirectURL) ? redirectURL.href.replace(encodeURI(url), url) : url;
    }

    text2p(text) {
        return text.trim().split(/\r?\n/).filter(line => line.trim() !== '').map(line => `<p>${line.trim()}</p>`).join('\n');
    }
}